import { useEffect, useRef } from 'react';
import axios from 'axios';
import { DigitexSsoLoading } from './DigitexSsoCallback';

const DigitexLogout = () => {
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const endSession = async () => {
      const token = localStorage.getItem('token');
      try {
        if (token) {
          await axios.post('/v1/logout', {}, {
            headers: { Authorization: `Bearer ${token}` },
          });
        }
      } catch {
        // Always clear the local session, including when its token expired.
      } finally {
        localStorage.removeItem('token');
        localStorage.removeItem('userDataDetail');
        localStorage.removeItem('agentDataDetail');
        window.location.replace('/');
      }
    };

    endSession();
  }, []);

  return <DigitexSsoLoading label="Disconnessione in corso" />;
};

export default DigitexLogout;
